import { render, staticRenderFns } from "./basicInfoForm.vue?vue&type=template&id=f1323380&scoped=true&"
import script from "./basicInfoForm.vue?vue&type=script&lang=js&"
export * from "./basicInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1323380",
  null
  
)

export default component.exports